module.exports = __webpack_public_path__ + "static/media/mobile-order-bullet-active.05579168.svg";